var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notification',{attrs:{"icon":"video","link":'/playlists/' + _vm.data.id,"title":"Playlist/booking conflict"}},[_c('template',{slot:"content"},[_vm._v(" Your playlist "),_c('span',{staticClass:"font-semibold"},[_vm._v(_vm._s(_vm.data.name))]),_vm._v(" has one or more booking conflicts. ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }